import config from "./config/config.json";

const getApiBaseUrl = () => {
    const hostname = window.location.hostname;

    if (hostname === "127.0.0.1" || hostname === "localhost") {
        // return config.API_ENDPOINT_LOCAL;
        return base_url + '/api/customer';
    } else if (hostname.startsWith("192.168.")) {
        return config.API_ENDPOINT_LAN;
    } else {
        // return config.API_ENDPOINT_PRODUCTION;
        return base_url + '/api/customer';
    }
};

export default getApiBaseUrl;
